import { CurrentUserQueryKeys } from 'gcs-common/clients/api/entities/current-user/current-user-api';
import { reactQueryClient } from '../../../clients/api/client';
import { getGetTasksQueryKey } from '../../../clients/api/entities/tasks/tasks-api-helpers';
import { channelMessagesUpsert } from '../messagesSlice';

const updateMessage =
  ({ message }) =>
  async (dispatch) => {
    const { channelId } = message;
    dispatch(channelMessagesUpsert({ channelMessages: { [channelId]: [message] } }));

    if (message.deleted) {
      setTimeout(() => {
        reactQueryClient.invalidateQueries({ queryKey: CurrentUserQueryKeys.GET_CURRENT_USER_FAVORITES });
        reactQueryClient.invalidateQueries({ queryKey: getGetTasksQueryKey(channelId) });
      }, 1500);
    }
  };

export default updateMessage;
